import { ComingSoon } from "components/commons";
import { Breadcum } from "components/commons/Breadcum";
import { activityTabs, tabs } from "helpers/constants";
import { useController } from "./Controller";
import { ActivitiesCard } from "../components/ActivitiesCard";
import { HoldersCard } from "../components/HoldersCard";
import { HoldingsCard } from "../components/HoldingsCard";
import { TradeCard } from "../components/TradeCard";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

function Activities() {
  const { currentTab, handleChangeTab, state } = useController();

  const tabRender = () => {
    switch (currentTab) {
      case "Activities":
        return <ActivitiesCard state={state} />;

      case "Trades":
        return <TradeCard state={state} />;

      case "Holders":
        return <HoldersCard state={state} />;

      case "Holdings":
        return <HoldingsCard state={state} />;

      default:
        break;
    }
  };

  return (
    <div className="flex-1 ">
      <Breadcum
        customTitle={
          <div className="flex gap-4 px-6">
            <img
              className="h-8 w-8 shadow-sm rounded-full object-fill"
              src={state?.avatar}
              alt=""
            />
            {state?.nickname}
          </div>
        }
      />
      <div className="w-full flex justify-evenly items-center gap-1 border-b border-gray-800 text-center px-1 mt-12 z-10">
        {activityTabs.map((tab) => (
          <div
            key={tab.name}
            className={classNames(
              tab.name === currentTab
                ? "border-secondary text-white"
                : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
              "whitespace-nowrap border-b-4 rounded text-sm font-normal py-2 w-full px-2 cursor-pointer"
            )}
            onClick={() => {
              handleChangeTab(tab.name);
            }}
          >
            {tab.name}
          </div>
        ))}
      </div>
      <div className="p-4">{tabRender()}</div>{" "}
    </div>
  );
}

export { Activities as default };
